import { RESET_APP_STATUS } from "../types";

export default function() {
  return {
    type: RESET_APP_STATUS
  };
}
